module.exports = __webpack_public_path__ + "slide5-release.c7ccddc7e6fbd65006a192e1c7fab55e.hashedasset.svg";